import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./features/user/userSlice";

export const store = configureStore({
  // user: {
  //   isLoggedin: false
  // }
  reducer: {
    user: userReducer,
  },
});

